"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumerableHelper = void 0;
class EnumerableHelper {
    static interval(startInclusive, endExclusive) {
        const array = [];
        for (let i = startInclusive; i < endExclusive; i++) {
            array.push(i);
        }
        return array;
    }
}
exports.EnumerableHelper = EnumerableHelper;
//# sourceMappingURL=enumerable.helper.js.map